import '.i{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.b4{min-height:100vh;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.c{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="i m n j b4 ae s c"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
